import React from "react";
import { Footer } from "../../../components/footer";
import Instructions from "../instructions";
import SimulatedHeader from "../Header";
import * as S from "./styles.js";

const SimulateStart = ({ loading, doStartSimulation, simulated, isResuming }) => {
  return (
    <>
      <S.Container>
        <SimulatedHeader simulated={simulated} title="Simulado" />
        <Instructions
          loading={loading}
          doStartSimulation={doStartSimulation}
          simulated={simulated}
          isResuming={isResuming}
        />
      </S.Container>
      <Footer />
    </>
  );
};

export default SimulateStart;
